(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-faq"] && !Shopify.designMode) return;
  try {
    
    /**
     * Progressive enhancement only. The accordions work without this.
     *
     * 1. Opens (and scrolls to) a question when the page loads with its hash, so blog
     *    posts and emails can deep-link straight to an answer.
     * 2. Mirrors the open question's hash into the address bar so a customer can share
     *    the answer they are looking at.
     */
    (function () {
      const SECTION = '.page-faq';

      function revealFromHash(hash, shouldScroll) {
        if (!hash || hash.length < 2) return;

        let target;
        try {
          target = document.querySelector(`${SECTION} ${hash}`);
        } catch (e) {
          return;
        }
        if (!target) return;

        const details = target.tagName === 'DETAILS' ? target : target.closest('details');
        if (details) details.open = true;

        if (shouldScroll) {
          // Defer so the expanded height is measured before scrolling
          requestAnimationFrame(function () {
            target.scrollIntoView({ block: 'start', behavior: 'smooth' });
          });
        }
      }

      function init() {
        if (!document.querySelector(SECTION)) return;

        revealFromHash(window.location.hash, true);
        window.addEventListener('hashchange', function () {
          revealFromHash(window.location.hash, true);
        });

        document.querySelectorAll(`${SECTION} .faq-item`).forEach(function (details) {
          details.addEventListener('toggle', function () {
            if (!details.open || !details.id) return;
            if (window.history && window.history.replaceState) {
              window.history.replaceState(null, '', `#${details.id}`);
            }
          });
        });
      }

      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
      } else {
        init();
      }
    })();
  
  } catch(e) { console.error(e); }
})();
})();
